<!-- 我的开发者主页 -->
<template>
    <div id="MyIndexWrap">
        <div class="PersonContentWrap">
<!--            <div class="ButtonWrap flexa">
                <div class="Time"><p>平台有效期至  2022-06-08</p></div>
                &lt;!&ndash;    <div class="flexa Auto"><span>自动续费</span> <el-switch
                            v-model="value"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                    </el-switch></div>&ndash;&gt;
                <div class="Button flexa">
                    <div class="flex Continue">续费</div>
                    <div class="flex Up">升级</div>
                </div>
            </div>
            <div class="Platform flex">
                <i><img src="../assets/pt1.png"></i>
                <i><img src="../assets/pt2.png"></i>
                <i><img src="../assets/pt3.png"></i>
            </div>-->
            <div @click="ClosePersonBox" class="Close"><img src="../assets/pclose.png"></div>
            <div class="SubmitButton flex" @click="Submit">确定</div>
            <div class="PersonHead flexa">
                <el-upload
                        class="HeadPic"
                        action=""
                        :accept="'image/*'"
                        :show-file-list="false"
                        :on-change="onchange">
                    <img v-if="SubmitData.Head" :src="SubmitData.Head" class="avatar">
                    <img v-else src="../assets/defaulthead.png" class="avatar">
                </el-upload>
                <div class="HeadText">
                    <i class="edit"><img src="../assets/editindex.png"></i>
                    <div class="Name">
                        <p><strong>HELLO<span style="color: red">!</span></strong></p>
                        <!--<p>{{ PersonData.Name }}</p>-->
                        <input v-model="SubmitData.Name" maxlength="20" />
                    </div>
                </div>
            </div>
            <div class="Info">
<!--                <div class="flexa"><img src="../assets/p_1icon.png">
                 <div class="AddressChoose flexa"><input  :placeholder="PersonData.City"/></div>
                </div>-->
                <div class="flexa ItemWrap"><img src="../assets/p_2icon.png"><input  v-model="SubmitData.Phone"  /></div>
                <div class="flexa ItemWrap"><img src="../assets/p_3icon.png"><input   v-model="SubmitData.Email" /></div>
            <!--    <div class="flexa"><img src="../assets/p_4icon.png"><input  :placeholder="PersonData.Number"/></div>-->
                <div class="Itemcard clearfix">
                    <div v-if="SubmitData.Items.length>0">
                    <div class="flex ItemList" v-for="(item,index) in SubmitData.Items" :key="index">{{ item }}<i @click="Delete(index)" class="delete"><img src="../assets/delete.png"></i></div>
                    </div>
                    <div class="flex AddItem"><el-button type="text"  @click="open">添加</el-button></div>
                </div>
            </div>
            <div class="LineCut flexbetween">
                <div class="NewsTitle flexa"><p>开发者 <span>简介</span></p></div>
            </div>
            <div class="Translate">
               <!-- <p>{{ PersonData.Info }}</p>-->
                <el-input
                        type="textarea"
                        resize="none"
                        v-model="SubmitData.Info"
                        maxlength="800"
                        show-word-limit
                >
                </el-input>
            </div>
        </div>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    name: 'myindex',
    components: {},
    props: {
      PersonData: Object,
      Userid: String
    },
    inject: [
      'load'
    ],
    data() {
      return {
        SubmitData: {
          Info: this.PersonData.Info,
          Head: this.PersonData.Head,
          Name: this.PersonData.Name,
          Items: this.PersonData.Items,
          Phone: this.PersonData.Phone,
          Email: this.PersonData.Email,
          Type: this.PersonData.Type,
          Time: this.PersonData.Time
        },
        value: true
      };
    },
    methods: {
      /* 删除标签 */
      Delete(index) {
        this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(index, this.SubmitData.Items[index]);
          this.SubmitData.Items.splice(index, 1);
        }).catch(() => {
          console.log('取消了注册');
        });
      },
      /* 提交修改数据 */
      Submit() {
        if (!this.$utils.checkEmail(this.SubmitData.Email)) {
          this.$message.error('邮箱不正确!');
        } else {
          this.$emit('Submit', this.SubmitData);
        }
      },
      compress(base64String, w, quality) {
        // var getMimeType = function(urlData) {
        //   var arr = urlData.split(",");
        //   var mime = arr[0].match(/:(.*?);/)[1];
        //   // return mime.replace("image/", "");
        //   return mime;
        // };
        var newImage = new Image();
        var imgWidth, imgHeight;

        var promise = new Promise(resolve => (newImage.onload = resolve));
        newImage.src = base64String;
        return promise.then(() => {
          imgWidth = newImage.width;
          imgHeight = newImage.height;
          var canvas = document.createElement('canvas');
          var ctx = canvas.getContext('2d');
          if (Math.max(imgWidth, imgHeight) > w) {
            if (imgWidth > imgHeight) {
              canvas.width = w;
              canvas.height = (w * imgHeight) / imgWidth;
            } else {
              canvas.height = w;
              canvas.width = (w * imgWidth) / imgHeight;
            }
          } else {
            canvas.width = imgWidth;
            canvas.height = imgHeight;
          }
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(newImage, 0, 0, canvas.width, canvas.height);
          // var base64 = canvas.toDataURL(getMimeType(base64String), quality);
          var base64 = canvas.toDataURL('image/jpeg', quality);
          axios.post('https://x6.goeasy.cn/file/FileSystem/Upload', {
            userId: this.Userid,
            files: JSON.stringify([{ filename: 'Head.JPG', content: base64 }])
          }).then(res => {
            if (res.data.code === 0) {
              this.load.hide();
              console.log(res.data.data.GoeasyUploadUrlFileName);
              this.SubmitData.Head = res.data.data.GoeasyUploadUrlFileName;
            }
          }).catch(error => {
            this.load.hide();
            console.log(error);
          });
        });
      },
      // 当上传图片后，调用onchange方法，获取图片本地路径
      onchange(file, fileList) {
        this.load.show();
        var _this = this;
        // eslint-disable-next-line no-use-before-define
        var event = event || window.event;
        // eslint-disable-next-line no-redeclare
        var file = event.target.files[0];
        var reader = new FileReader();
        let isJPG = file.type;
        let isLt20M = file.size / 1024 / 1024 <= 4;
        console.log(file.size);
        console.log(file.type);
        if (isJPG !== 'image/jpeg' && isJPG !== 'image/png') {
          _this.$message.error('上传图片只能是 JPG/PNG 格式!');
          setTimeout(() => {
            this.load.hide();
          }, 1000);
        } else if (!isLt20M) {
          console.log(isLt20M);
          _this.$message.error('图片大小不能超过 5MB!');
          setTimeout(() => {
            this.load.hide();
          }, 1000);
        } else {
          reader.onload = function(e) {
            _this.compress(e.target.result, 1024, 0.8);
            /* _this.Data.personimg = e.target.result //将图片路径赋值给src */
          };
          reader.readAsDataURL(file);
          setTimeout(() => {
            this.load.hide();
          }, 1000);
        }
        // 转base64
      },
      open() {
        if (this.SubmitData.Items.length === 10) {
          this.$message({
            message: '标签数量不能超过10个！',
            type: 'warning'
          });
        } else {
          this.$prompt('每个标签最多输入十个字,标签数量不得超过10个。', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^\s*([^\s]\s*){1,10}$/,
            inputErrorMessage: '请输入长度在1-10内的内容！'
          }).then(({ value }) => {
            this.SubmitData.Items.push(value);
          }).catch(() => {

          });
        }
      },
      ClosePersonBox() {
        this.$emit('OpenEdit');
      }
    }
    /*    watch: {
      SubmitData: {
        handler(val, oldValue) {
          if (val !== oldValue) {
            this.ChangeState = true;
          } else {
            this.ChangeState = false;
          }
        },
        deep: true
      }
    } */
  };
</script>
<style scoped lang="scss">
    @import '../../public/Value';
    #MyIndexWrap{
        .Platform{
            width: 96%;
            margin: 0 auto 0.15rem;
            i{
                width: 31%;
                cursor: pointer;
                img{
                    width: 100%;
                }
            }
            i:nth-child(2){
                margin: 0 2%;
            }
        }
        .ButtonWrap{
            width: 93%;
            height: 0.11rem;
            margin: 0 auto 0.1rem;
            position: relative;
            .Time{
                font-size: $TextSize;
                color: #666666;
            }
            .Button{
                position: absolute;
                right: 0;
            }
            .Up,.Continue{
                width: 0.36rem;
                height: 0.11rem;
                border-radius: 0.12rem;
                font-size: $AdditionTextSize;
                color: #fff;
                margin-left: 0.1rem;
                cursor: pointer;
            }
            .Continue{
                background-color: #cc9900;
            }
            .Up{
                background-color: #0066cc;
            }
        }
        .SubmitButton{
            width: 0.36rem;
            height: 0.11rem;
            border-radius: 0.12rem;
            font-size: 0.051rem;
            color: #fff;
            margin-left: 0.1rem;
            cursor: pointer;
            background-color: #fb7535;
            position: absolute;
            right: 0.15rem;
            top: 0.3rem;
        }
        .Close{
            width: 0.12rem;
            height: 0.12rem;
            position: absolute;
            right: 0.06rem;
            top: 0.06rem;
            cursor: pointer;
            img{
                width: 100%;
                height: 100%;
            }
        }
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #f5f5f5;
        border-radius: 0.06rem 0.06rem 0 0;
        padding-top: 1px;
        background-image: url("../assets/logobg.png");
        background-repeat: no-repeat;
        background-size: 2.3rem;
        background-position: right top;
        .PersonContentWrap{
            .Translate{
                width: 93%;
                padding: 0.1rem;
                height: 0.7rem;
                margin: 0.1rem auto 0;
                box-sizing: border-box !important;
                background-color: #fff;
                border-radius: 0.1rem;
                box-shadow: 0 0 10px #e2e2e2;
                ::v-deep .el-textarea{
                    height: 100%;
                    textarea{
                        font-size: $AdditionTextSize;
                        color: #000;
                        padding: 0;
                        height: 100%;
                        border: 0;
                    }
                }
                ::v-deep .el-textarea__inner{
                    background-color: rgba(0,0,0,0) !important;
                    border-radius: 0.04rem !important;
                    color: #fff;
                }
                ::v-deep  .el-input__count{
                    background-color: rgba(0,0,0,0) !important;
                    color: #000;
                    opacity: 0.6;
                    bottom: -0.08rem !important;
                    right: 0.01rem !important;
                }
            }
            .LineCut{
                width: 93%;
                margin: 0.05rem auto 0.05rem;
                border-bottom: 2px solid #000;
                .Return{
                    cursor: pointer;
                    p{
                        font-size: $AdditionTextSize;
                        color: #fff;
                    }
                    img{
                        width: 0.05rem;
                        margin-left: 0.02rem;
                    }
                }
                .NewsTitle{
                    p{
                        font-size: $TitleSize;
                        color: #000;
                        padding-bottom: 0.045rem;
                        span{
                            opacity: 0.6;
                            font-weight: normal;
                        }
                    }
                }
            }
            .Info{
                margin-left: 0.12rem;
                margin-top: 0.07rem;
                .ItemWrap{
                    height: 0.18rem;
                    img{
                        width: 0.075rem;
                    }
                    p{
                        font-size:$TextSize;
                        color: #000;
                        margin-left: 0.08rem;
                    }
                    input{
                        font-size:$AdditionTextSize;
                        color: #000;
                        text-indent: 0.05rem;
                        margin-left: 0.03rem;
                        width: 0.83rem;
                        height: 0.1rem;
                        border-radius: 0.1rem;
                        background-color:#e8e8e8;
                    }
                }
                .Itemcard{
                    width: 90%;
                    margin-top: 0.05rem;
                    .ItemList,.AddItem{
                        height: 0.1rem;
                        padding: 0 0.08rem;
                        box-sizing: border-box;
                        background-color: #999999;
                        color: #fff;
                        border-radius: 0.1rem;
                        font-size: $AdditionTextSize;
                        margin-right: 0.05rem;
                        float: left;
                        margin-bottom: 0.05rem;
                        position: relative;
                        .delete{
                            width: 0.06rem;
                            position: absolute;
                            right: 0;
                            top: -0.01rem;
                            cursor: pointer;
                            img{
                                width: 100%;
                            }
                        }
                    }
                    .AddItem{
                        background-color: #00a7e6;
                        ::v-deep .el-button--text{
                            color: #fff;
                            cursor: pointer;
                        }
                    }
                }
            }
            .PersonHead{
                width: 1.5rem;
                height: 0.4rem;
                margin-left: 0.1rem;
                position: relative;
                .HeadPic img{
                    width:0.4rem;
                    height: 0.4rem;
                    object-fit: cover;
                    border-radius: 0.08rem;
                }
                .HeadText{
                    height: 0.4rem;
                    margin-left: 0.06rem;
                    .edit{
                        width: 0.09rem;
                        margin-bottom: 0.12rem;
                        margin-top: 0.02rem;
                        cursor: pointer;
                        opacity: 0;
                        pointer-events: none;
                        img{
                            width: 100%;
                        }
                    }
                    .Name{
                        input{
                            font-size: $TextSize;
                            color: #000;
                            background-color:#e8e8e8;
                            width: 0.5rem;
                            height: 0.09rem;
                            border-radius: 0.08rem;
                            text-indent: 0.05rem;
                        }
                        p{
                            font-size: $SmallTitleSize;
                            margin-bottom: 0.02rem;
                        }
                    }
                }
            }
            width: 96%;
            margin: 0 auto;
            height: calc(100% - 0.25rem);
            margin-top: 0.25rem;
            overflow-y: scroll;
            overflow-x: hidden;
            padding-bottom: 0.2rem;
            box-sizing: border-box !important;
            &::-webkit-scrollbar {
                width: 2px;
                height: 2px;
            }
            &::-webkit-scrollbar-track {
                width: 2px;
                background: #d2d2d2;

            }

            &::-webkit-scrollbar-thumb {
                width: 2px;
                background: #444444;
            }
        }
    }
</style>
